import React from "react";
import PublicLayout from "../components/PublicLayout";

export default function TermsPage() {
  React.useEffect(() => {
    document.title = "Terms of Service | Bark Buddies";
  }, []);
  const updated = "February 2026";
  return (
    <PublicLayout>
      <section className="mx-auto max-w-3xl px-5 md:px-8 pt-12 md:pt-16 pb-24" data-testid="terms-page">
        <div className="text-[12px] font-bold uppercase tracking-widest text-bark-teal">Legal</div>
        <h1 className="mt-2 text-4xl sm:text-5xl font-black tracking-tight text-bark-ink">
          Terms of Service
        </h1>
        <p className="mt-3 text-[13px] text-bark-muted">Last updated: {updated}</p>

        <div className="mt-8 bg-white rounded-[28px] shadow-bark-soft p-6 md:p-10 legal-prose">
          <p>
            Welcome to <strong>Bark Buddies</strong>! These Terms of Service ("Terms") govern your
            use of the Bark Buddies mobile app, website, and related services (the "Services").
            By creating an account or using the Services, you agree to these Terms.
          </p>

          <h2>1. Eligibility & accounts</h2>
          <p>
            You must be at least 13 years old (or the minimum age in your jurisdiction) to use
            Bark Buddies. You are responsible for your account credentials and everything that
            happens under your account. Provide accurate information and keep it up to date.
          </p>

          <h2>2. Dog meetups & real-world safety</h2>
          <p>
            Bark Buddies helps you connect with other dog owners and schedule playdates. Meeting
            other people and their dogs happens at your own risk. We <strong>strongly</strong>{" "}
            recommend:
          </p>
          <ul>
            <li>Meet the first time in a public place (e.g. a dog park).</li>
            <li>Keep dogs leashed for introductions, and follow local leash laws.</li>
            <li>Read the other dog's profile carefully — size, energy, temperament.</li>
            <li>Never proceed if either dog seems stressed, fearful, or aggressive.</li>
            <li>Bring current vaccination records and be honest about your dog's history.</li>
          </ul>
          <p>
            You are solely responsible for your dog's behavior and the behavior of anyone you
            invite to a meetup.
          </p>

          <h2>3. User content</h2>
          <p>
            You retain ownership of the content you post (dog photos, profiles, messages). By
            posting, you grant Bark Buddies a worldwide, non-exclusive license to host, display,
            and process that content solely to operate the Services. Do not post content you
            don't have the right to share.
          </p>

          <h2>4. Messaging</h2>
          <p>
            Messaging is only available after a buddy request is accepted. Messages should relate
            to arranging playdates or discussing dogs. Harassment, threats, spam, sexually
            explicit content, and off-platform solicitation are prohibited.
          </p>

          <h2>5. Reports & blocks</h2>
          <p>
            You can report or block any user from inside the app. We may remove content, suspend,
            or terminate accounts that violate these Terms or that we believe pose a safety risk
            to the community.
          </p>

          <h2>6. No veterinary or professional advice</h2>
          <p>
            Bark Buddies is a social/playdate app, not a veterinary service. Information in the
            Services is not medical advice. Always consult a licensed veterinarian for health,
            behavior, or training concerns about your dog.
          </p>

          <h2>7. Prohibited uses</h2>
          <ul>
            <li>Do not use the Services to breed, sell, or transfer ownership of dogs.</li>
            <li>Do not organize dog fights or any activity that harms animals.</li>
            <li>Do not impersonate others or misrepresent your dog's temperament.</li>
            <li>Do not attempt to scrape, reverse-engineer, or disrupt the Services.</li>
          </ul>

          <h2>8. Beta program</h2>
          <p>
            If you join the Android Bark Buddies beta, you understand the Services are pre-release, may
            contain bugs, and are provided "as is" without warranty. You agree to provide
            reasonable feedback and to keep confidential any non-public details of the Services.
          </p>

          <h2>9. Termination</h2>
          <p>
            You may delete your account at any time by using the in-app option or emailing
            support. We may suspend or terminate your account for violations of these Terms or if
            required by law.
          </p>

          <h2>10. Disclaimers & limitation of liability</h2>
          <p>
            The Services are provided "as is" and "as available." To the maximum extent permitted
            by law, Bark Buddies is not liable for indirect, incidental, or consequential damages
            arising from your use of the Services or from any interaction with other users or
            their dogs.
          </p>

          <h2>11. Changes</h2>
          <p>We may update these Terms. Continued use of the Services after changes means you accept them.</p>

          <h2>12. Contact</h2>
          <p>
            Questions about these Terms? Email{" "}
            <a className="bark-link" href="mailto:support@barkbuddies.app">support@barkbuddies.app</a>.
          </p>
        </div>
      </section>
    </PublicLayout>
  );
}
